import useDeviceHardwareAgentCaller from 'hooks/useHardwareAgentCaller/useDeviceHardwareAgentCaller'
import { useCallback, useEffect } from 'react'
import { CallerIdMessage, DeviceStatusEventType } from '../Devices/types'
import useCallerIdHubReducer from './useCallerIdHubReducer'
import { deviceStatusSubjects } from '../hwAgentSubjects'
import useDefaultDevice from 'hooks/useDefaultDevice/useDefaultDevice'

const useCallerIdHub = () => {
    const { dispatch, state } = useCallerIdHubReducer()
    const { callerIdHardwareAgentUri } = useDefaultDevice()

    const {
        getActiveCallerIdMessages,
        removeActiveCallerId,
    } = useDeviceHardwareAgentCaller(callerIdHardwareAgentUri)

    const activePhoneCallerInfos = state.activePhoneCallerInfos

    const loadActiveCallerIdMessages = useCallback(async () => {
        const res = await getActiveCallerIdMessages()
        dispatch({
            type: 'LOAD_PHONE_CALLER_INFOS',
            payload: res.data,
        })
    }, [dispatch, getActiveCallerIdMessages])

    const updateCallerIdMessage = useCallback(
        (message: CallerIdMessage) => {
            dispatch({
                type: 'UPDATE_PHONE_CALLER_INFO',
                payload: message,
            })
        },
        [dispatch],
    )

    const removeCallerIdMessage = useCallback(
        async (phoneNumber: string) => {
            dispatch({
                type: 'REMOVE_PHONE_CALLER_INFO',
                payload: phoneNumber,
            })

            await removeActiveCallerId(phoneNumber)
        },
        [removeActiveCallerId, dispatch],
    )

    // handle phone caller
    useEffect(() => {
        const subscription = deviceStatusSubjects.subscribe((message) => {
            if (message.eventType === DeviceStatusEventType.OnReceiveCallerId) {
                updateCallerIdMessage(message.data)
            }
        })

        return () => {
            subscription.unsubscribe()
        }
    }, [updateCallerIdMessage])

    return {
        activePhoneCallerInfos,
        loadActiveCallerIdMessages,
        updateCallerIdMessage,
        removeCallerIdMessage,
    }
}

export default useCallerIdHub
